function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M0,24H24V0H0M17.77,15.78a4.11,4.11,0,0,1-.07.86,2.11,2.11,0,0,1-.34.8,2,2,0,0,1-.64.6,2.71,2.71,0,0,1-.81.29,3.13,3.13,0,0,1-1.26.07,1.73,1.73,0,0,1-.84-.43,1.81,1.81,0,0,1-.59-1.16,1.84,1.84,0,0,1,.49-1.46,2,2,0,0,1,.76-.48,8.74,8.74,0,0,1,1.29-.33l.46-.09a.77.77,0,0,0,.5-.26.86.86,0,0,0,.14-.58V8.46c0-.4-.17-.5-.55-.43l-6,1.22c-.33.07-.44.18-.44.59v7.55a4.11,4.11,0,0,1-.08.86,2.11,2.11,0,0,1-.34.8,2,2,0,0,1-.64.6,2.44,2.44,0,0,1-.82.29A3.08,3.08,0,0,1,6.69,20a1.76,1.76,0,0,1-.85-.43,1.9,1.9,0,0,1-.58-1.16A1.88,1.88,0,0,1,5.75,17a1.91,1.91,0,0,1,.76-.48,7.39,7.39,0,0,1,1.29-.33l.45-.09a.79.79,0,0,0,.51-.26.84.84,0,0,0,.15-.57V6.52a1.06,1.06,0,0,1,0-.23.73.73,0,0,1,.23-.45,1.07,1.07,0,0,1,.43-.2h0l7-1.41.62-.1c.38,0,.59.21.59.61v11Z",
    style: {
      "fill": "#969b9d"
    }
  }));
};

export default __webpack_public_path__ + "static/media/apple.08b3bd1e.svg";
export { SvgComponent as ReactComponent };